// client/components/HintPencil.tsx
// Pencil icon overlay for quick-edit mode

import React from "react";
import { Pencil } from "lucide-react";

export function HintPencil({ onClick }:{ onClick: ()=>void }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="absolute -top-2 -right-2 p-1 rounded-full shadow bg-white hover:bg-gray-100 z-10"
      aria-label="Edit hint"
    >
      <Pencil size={14} />
    </button>
  );
}
